import { lazy } from 'react';

export const RequisitionsList = lazy(() => import('./pages/RequisitionsList'));
export const RequisitionNew = lazy(() => import('./pages/RequisitionNew'));
export const RequisitionDetail = lazy(() => import('./pages/RequisitionDetail'));

export { REQUISITION_ROUTES } from './paths';
